import { render, staticRenderFns } from "./companyDepartments.vue?vue&type=template&id=1bbd46e8&scoped=true&"
import script from "./companyDepartments.vue?vue&type=script&lang=js&"
export * from "./companyDepartments.vue?vue&type=script&lang=js&"
import style0 from "./companyDepartments.vue?vue&type=style&index=0&id=1bbd46e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd46e8",
  null
  
)

export default component.exports